import { useQuery } from '@tanstack/react-query';

import { useRequest, type QueryFunction } from '@frontend/api';

export type AgentModelOption = {
  modelKey: string;
  name: string;
  description: string;
};

export const getUseListModelOptionsKey = () => ['agents', 'model-options'];

export const useListModelOptions: QueryFunction<
  AgentModelOption[],
  [],
  ReturnType<typeof getUseListModelOptionsKey>
> = ({ queryOptions, requestOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getUseListModelOptionsKey(),
    queryFn: ({ signal }) => {
      return request<AgentModelOption[]>(`/agents/model-options`, {
        init: {
          signal,
        },
      });
    },
  });
};
